module.exports = __webpack_public_path__ + "static/availability-74675af12fb8834043bef888f478de58.png";